import { api } from "@/lib/api";

export interface ChatAttachment {
  id: string;
  file_name: string;
  mime_type: string;
  size_bytes: number;
}

export interface ChatMessage {
  id: string;
  room_id: string;
  sender_id: string;
  sender_name: string;
  body: string;
  attachment: ChatAttachment | null;
  sent_at: string;
  read_by_others: boolean;
}

export interface ChatRoom {
  id: string;
  ticket_id: string | null;
  messages: ChatMessage[];
  unread_count: number;
}

export function openRoom(ticketId: string): Promise<ChatRoom> {
  return api.get<ChatRoom>(`/tickets/${ticketId}/chat`);
}

export function roomMessages(roomId: string): Promise<ChatMessage[]> {
  return api.get<ChatMessage[]>(`/chat/rooms/${roomId}/messages`);
}

export function postMessage(
  roomId: string,
  body: { body: string; attachment_id?: string | null },
): Promise<ChatMessage> {
  return api.post<ChatMessage>(`/chat/rooms/${roomId}/messages`, body);
}

export function markRead(roomId: string): Promise<{ message: string }> {
  return api.post<{ message: string }>(`/chat/rooms/${roomId}/read`, {});
}

// Fire-and-forget typing ping — throttled by the caller, never awaited hard.
export function signalTyping(roomId: string): Promise<unknown> {
  return api.post(`/chat/rooms/${roomId}/typing`, {});
}
